import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import {
  uploadImportFile,
  downloadTemplate,
  executeImport,
  downloadFailures,
  deleteImportFile
} from '@/views/Expedients/components/ImportExpedientsDialog/services/ImportExpedientsService'
import {
  ImportSummary,
  UploadImportFileResponse
} from '@/views/Expedients/components/ImportExpedientsDialog/types/ImportExpedientsDialogTypes'

export const useImportExpedientsProcessStore = defineStore('importExpedientProcess', () => {
  const importId = ref<string | undefined>()
  const importSummary = ref<ImportSummary | undefined>()
  const hasImportId = computed(() => !!importId.value)
  const hasFailures = computed((): boolean => {
    const failureCount = importSummary.value?.failureCount
    return failureCount !== undefined && failureCount > 0
  })
  const hasSummaryError = computed((): boolean => {
    const summaryError = importSummary.value?.summaryError
    return summaryError !== undefined && summaryError
  })
  const init = () => {
    importId.value = undefined
    importSummary.value = undefined
  }
  const finish = () => init()
  const uploadImportExpedientFile = async (file: File): Promise<UploadImportFileResponse> => {
    const response = await uploadImportFile(file)
    if (response?.importId) {
        importId.value = response.importId
    }

    return response
  }
  const executeExpedientImport = async () => {
    if(!importId.value) {
      throw Error('importId missing')
    }
    const response = await executeImport(importId.value)
    if (response.success) {
      importSummary.value = {
        successCount: Number(response.successCount),
        failureCount: Number(response.failureCount),
      }
    } else {
      importSummary.value = {
        summaryError: true,
        successCount: 0,
        failureCount: 0,
      }
    }
  }
  const downloadImportExpedientsTemplate = () => downloadTemplate()
  const downloadFailureImportExpedientsFile = () => {
    if(!importId.value) {
      throw Error('importId missing')
    }
    return downloadFailures(importId.value)
  }
  const deleteImportExpedienteFile = async () => {
    if(!importId.value) {
      return
    }
    await deleteImportFile(importId.value)
    importId.value = undefined
  }

  return {
    finish,
    init,
    uploadImportExpedientFile,
    downloadImportExpedientsTemplate,
    executeExpedientImport,
    downloadFailureImportExpedientsFile,
    deleteImportExpedienteFile,
    importSummary,
    hasImportId,
    hasFailures,
    hasSummaryError,
    importId
  }
})
